module.exports = function(app) {
	app.directive('eprResourceBlock', [function() {
		return {

			restrict: 'A',
			replace: false,
			template: require('directives/home/eprResourceBlock.html'),

			scope: {
				resource: '=eprResourceBlock'
			}
		};
	}]);
};
